<template>
  <div class="main-page">
    <div class="video-area">
      <video style="width: 100%" autoplay muted loop="loop">
        <source src="@/assets/videos/djxinxi_video.mp4" type="video/mp4" />
      </video>
      <el-carousel trigger="click" class="common-width company-slogan-area" :indicator-position="'none'" :arrow="'never'" :pause-on-hover="false" :autoplay="false" ref="sloganCarousel">
        <el-carousel-item>
          <div class="company-title">上海洞见信息科技有限公司</div>
          <div class="company-slogan company-slogan1">做有价值的事，持续创造价值</div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="company-title">洞察趋势 预见未来</div>
          <div class="company-slogan company-slogan0">给管理人员提供数据 | 给技术人员提供工具</div>
        </el-carousel-item>
      </el-carousel>
    </div>



    <div class="common-width main-func-area-margin-top">
      <div class="title1 company-intro1">公司介绍</div>
      <div class="title2 company-intro2">Company introduction</div>
      <div class="company-bg">
        <div class="company-text-content">
          上海洞见信息科技有限公司专注于通过大数据分析帮助企业改善生产管理、提高劳动生产力；提供专业的软件产品和相关咨询服务，助力企业通过数字孪生技术实现智能工厂的建设。洞见信息-解决方案及服务优势：为客户提供化工专业 + 自动化
          + 信息化 “ 三化一体” 的专业服务；为客户提供不定时作息以满足客户特殊的需求；为客户提供大石油化工、医药化工、煤化工、精细化工、工业等行业解决方案；覆盖企业工艺、设备、人员、生产监控和报警管理等多个领域。
        </div>
      </div>
    </div>

    <div class="main-technical-capability main-func-area-margin-top">
      <div class="common-width main-technical-capability-content">
        <div style="margin-top: 72px;">
          <div class="title1" style="color: #ffffff">技术能力</div>
          <div class="title2" style="color: rgba(255,255,255,0.26)">Technical capability</div>
        </div>
        <div class="float-ball" style="left: 240px;top: 200px;position: absolute" >
          <float-tech-ball-view :percent="0.79" :tech-name="'边缘计算'"/>
        </div>
        <div class="float-ball" style="left: 366px;top: 430px;position: absolute" >
          <float-tech-ball-view :percent="0.88" :tech-name="'区块链'"/>
        </div>
        <div class="float-ball" style="left: 520px;top: 226px;position: absolute" >
          <float-tech-ball-view :percent="0.95" :tech-name="'大数据'"/>
        </div>
        <div class="float-ball" style="left: 840px;top: 88px;position: absolute" >
          <float-tech-ball-view :percent="0.82" :tech-name="'人工智能'"/>
        </div>
        <div class="float-ball" style="left: 1000px;top: 280px;position: absolute" >
          <float-tech-ball-view :percent="0.75" :tech-name="'数据安全'"/>
        </div>
      </div>
    </div>

    <div class="main-product common-width main-func-area-margin-top">
      <div style="width: 100%; display: flex; justify-content: center">
        <div class="title1" style="color: #666666">我们的产品</div>
        <div class="title1" style="position:relative;">
          <div class="title2" style="color: #666666;position:absolute;bottom: 4px">Product</div>
        </div>
      </div>
      <div class="main-product-item-area">
        <main-product-item v-for="mainproduct in mainProductInfos" :main-product-item = "mainproduct"/>
      </div>
    </div>

    <div class="main-solution main-func-area-margin-top">
      <div style="margin: 0 auto" class="common-width">
        <div class="title1" style="color: #666666;display: block">解决方案</div>
        <div class="title2" style="color: #666666;display: block">Solution</div>
        <div class="main-solution-grid">
          <div class="solution-item main-solution-item0">
            上海洞见信息科技有限公司依托可靠的大数据开发技术，采用先进的“ 三化一体” 整体解决方案模式，为企业提供智能化改造、工业云平台建设、数据和网络安全和大数据应用等服务。
          </div>
          <main-solution-item v-for="mainSolutionInfo in mainSolutionInfos" :main-solution-info="mainSolutionInfo"/>
        </div>
      </div>
    </div>

    <div class="main-news common-width main-func-area-margin-top">
      <div class="title1" style="color: #666666;display: block">新闻中心</div>
      <div class="title2" style="color: #B8BAC0;display: block">News</div>
      <div class="main-news-grid1">
        <div class="main-news-item" v-if="newsItemData[4]" @click="newItemClick(4)">
          <new1 :newsData="newsItemData[4]" :newsStyle="{style:0}" />
        </div>
        <div class="main-news-item" v-if="newsItemData[0]" @click="newItemClick(0)">
          <new1 :newsData="newsItemData[0]" :newsStyle="{style:1}" />
        </div>
        <div class="main-news-item" v-if="newsItemData[1]" @click="newItemClick(1)">
          <new1 :newsData="newsItemData[1]" :newsStyle="{style:1}" />
        </div>
      </div>
      <div class="main-news-grid2">
        <div class="main-news-item" v-if="newsItemData[2]" @click="newItemClick(2)">
          <new1 :newsData="newsItemData[2]" :newsStyle="{style:1}" />
        </div>
        <div class="main-news-item" v-if="newsItemData[3]" @click="newItemClick(3)">
          <new1 :newsData="newsItemData[3]" :newsStyle="{style:1}" />
        </div>
        <div class="main-news-item-more" @click="newItemClick(-1)">更多>></div>
      </div>
    </div>

    <div class="main-customer common-width main-func-area-margin-top">
      <div style="width: 100%;top: 0;;display: flex;justify-content: center;">
        <div class="title1" style="color: #666666">合作伙伴</div>
        <div class="title1" style="position:relative;">
          <div class="title2" style="color: #B8BAC0;bottom: 4px">Customer</div>
        </div>
      </div>
      <div class="main-customer-bg" />
    </div>

  </div>
</template>

<script>

import New1 from "@/views/New1";
import { ref,onMounted,onUnmounted } from "vue";
import constants from "@/api/constants";
import {useRouter} from "vue-router";
import MainProductItem from "@/views/MainProductItem";
import MainSolutionItem from "@/views/MainSolutionItem";
import FloatTechBallView from "@/views/FloatTechBallView";

export default {
  name: "MainPage",
  components: { FloatTechBallView, MainSolutionItem, MainProductItem, New1 },
  setup() {
    const router = useRouter();
    const sloganCarousel = ref(null);
    function newItemClick(newsItem){
      if (newsItem < 0 || newsItem > constants.newsItemData.length){
        router.push({ path: "/news"});
      }else {
        router.push({ name: "NewsDetailPage", params: { id: newsItem } });
      }
    }
    let timer = null;
    onMounted(()=>{
      timer = setTimeout(()=>{
        sloganCarousel.value.next();
      },3000)
    });
    onUnmounted(()=>{
      if (timer != null){
        clearTimeout(timer)
      }
    })
    const newsItemData = ref(constants.newsItemData);
    const mainProductInfos = ref(constants.mainProductInfos);
    const mainSolutionInfos = ref(constants.mainSolutionInfos);
    return {
      newsItemData,
      newItemClick,
      mainProductInfos,
      mainSolutionInfos,
      sloganCarousel,
    };
  }
};
</script>

<style scoped>
.main-page {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-area{
  width: 100%;
  position: relative;
}

.company-slogan-area{
  position: absolute;
  top: 323px;
  left: 50%;
  transform: translateX(-50%);
}

.company-title{
  color: white;
  font-size: 70px;
  width: 100%;
  text-align: center;
}

.float-ball{
  width: 100px;
  height: 100px;
  -webkit-animation: bounce-down 3s linear infinite;
  animation: bounce-down 3s linear infinite;
}

@-webkit-keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-8px);
  }
  50%, 100% {
    -webkit-transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(8px);
  }
}

@keyframes bounce-down {
  25% {
    transform: translateY(-8px);
  }
  50%, 100% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(8px);
  }
}

.company-slogan{
  color: white;
  font-size: 35px;
  height: 87px;
  line-height: 87px;
  text-align: center;
  background-color:rgba(63,142,226,0.5);
  margin-top: 70px;
  display: inline-block;
  padding:0 20px;
  /*transform: translateX(-50%);*/
  /*margin-left: 50%;*/
}
.company-slogan0{
  margin-left: 255px;
}
.company-slogan1{
  margin-left:360px


}

.company-intro1 {
  color: #423f54;
}

.company-intro2 {
  color: #B8BAC0;
}

.company-bg {
  background-image: url("./../assets/images/company-bg.png");
  background-size: cover;
  width: 100%;
  height: 620px;
  position: relative;
}

.company-text-content {
  width: 816px;
  position: absolute;
  bottom: 0;
  color: #666666;
  line-height: 40px;
  font-size: 16px;
  letter-spacing: 2px;
}

.main-technical-capability {
  background-image: url("./../assets/images/main-technical-capability-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 700px;
}

.main-technical-capability-content{
  position: relative;
  margin: 0 auto;
  border: 1px solid transparent;
  box-sizing:border-box;
  height: 100%;
}

.main-product {

}
.main-product-item-area{
  margin-top: 95px;
  display: flex;
  justify-content:space-between ;
}

.main-solution {
  background-color: #F3F3F3;
  width: 100%;
  padding-top: 73px;
  padding-bottom: 65px;
}

.main-solution-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.solution-item {
  width: 380px;
  height: 336px;
  border: 1px solid #00A0E9;
  font-size: 16px;
  line-height: 40px;
  color: #666666;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main-solution-item0 {
  box-sizing: border-box;
  padding: 58px 46px 0px 46px;
  border: 0;
}

.solution-item:nth-child(n+4) {
  margin-top: 25px;
}


.main-news {

}

.main-news-grid1 {
  position: relative;
  margin-top: 45px;
  height: 402px;
  width: 100%;
}

.main-news-item {
  width: 380px;
  height: 185px;
  cursor: pointer;
}

.main-news-grid1 .main-news-item:nth-child(1) {
  width: 797px;
  height: 402px;
  position: absolute;
}

.main-news-grid1 .main-news-item:nth-child(2) {
  top: 0;
  right: 0;
  position: absolute;
}

.main-news-grid1 .main-news-item:nth-child(3) {
  right: 0;
  bottom: 0;
  position: absolute;
}

.main-news-item-more {
  background-color: #72B5FD;
  width: 380px;
  height: 185px;
  line-height: 185px;
  color: white;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}

.main-news-grid2 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 185px;
  margin-top: 30px;
}

.main-customer {
  height: 560px;
}

.main-customer-bg {
  background-image: url("./../assets/images/main-customer-bg.png");
  background-size: cover;
  width: 1202px;
  height: 400px;
  position: absolute;
  margin-top: 55px;
  box-shadow: 0 0 30px rgba(0, 0, 22, 0.3);
}

</style>
